import Carousel from 'react-bootstrap/Carousel';
import { Link } from "react-router-dom";
import SliderData from '../menhome/SliderImages.json';
import Marquee from "react-fast-marquee";
import MarqueeData from '../menhome/MarqueeData.json';
import './SliderCSS.css';

function DarkVariantExample() {
    const today = new Date();
    const filterMarqueeData = MarqueeData.filter(item => item.Status ===1);
    // const filterSliderData = SliderData.filter(item => item.status ===1);
    
 // Slider filter + priority logic
    const filterSliderData = SliderData.filter(item => {
        const start = item.startDate ? new Date(item.startDate) : null;
        const end = item.endDate ? new Date(item.endDate) : null;

        return (
            item.status === 1 &&
            (!start || today >= start) &&
            (!end || today <= end)
        );
    })
    .sort((a, b) => Number(a.priority ?? 999) - Number(b.priority ?? 999));



    return (
        <>
        <Marquee pauseOnHover={true} speed={60}  delay={1} >
                    {filterMarqueeData.map((item, index) => (
                        
                        <a className={`me-2 ${item.blink === 'yes' ? 'glowing-text c-link' : ''}`}
                            key={index}
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          
                        >
                            <img src="assets/img/icon/new.gif" alt="iconNew" height={16} />
                            {item.desc}   
                            {index !== filterMarqueeData.length - 1 && (
                            <span className='me-2 ms-3'>|</span>)}
                        </a>
                      
                    ))}
                </Marquee>
        <Carousel fade>
            {filterSliderData.map((item, index) => (
                <Carousel.Item key={index} style={{ backgroundImage: `url(${item.image})` }}>
                    <div
                        className="carousel-backdrop"
                        style={{ backgroundImage: `url(${item.image})` }}
                    />
                    <Link to={item.href} target="_blank" rel="noopener noreferrer" >
                        <div
                            className="carousel-foreground"
                            style={{ backgroundImage: `url(${item.image})` }}
                        >     </div>
                    </Link>
                    {item.title || item.subtitle ? ( 
                    <Carousel.Caption style={{ backgroundColor: 'rgba(26,29,30,0.6)', color: 'white', borderRadius: '10px' }}>
                        <h4>{item.title}</h4>
                        <p>{item.subtitle}</p>
                    </Carousel.Caption>
                    ):null}
                </Carousel.Item>
            ))}
        </Carousel>

        {/* <div className="container-fluid mt-3">
            <div className="row">
                
                <div className="col-md-9 col-12" >
                <Carousel fade>
                    {filterSliderData.map((item, index) => (
                    <Carousel.Item key={index} style={{ backgroundImage: `url(${item.image})` }}>
                        <div
                        className="carousel-backdrop"
                        style={{ backgroundImage: `url(${item.image})` }}
                        />
                        <Link to={item.href} target="_blank" rel="noopener noreferrer">
                        <div
                            className="carousel-foreground"
                            style={{ backgroundImage: `url(${item.image})` }}
                        ></div>
                        </Link>
                        {item.title || item.subtitle ? (
                        <Carousel.Caption style={{ backgroundColor: 'rgba(26,29,30,0.6)', color: 'white', borderRadius: '10px' }}>
                            <h4>{item.title}</h4>
                            <p>{item.subtitle}</p>
                        </Carousel.Caption>
                        ) : null}
                    </Carousel.Item>
                    ))}
                </Carousel>
                </div>
               
                <div className="col-md-3 col-12 mt-3 mt-md-0"  >
                <div className="ms-2 p-4 shadow rounded h-100" style={{backgroundColor : '#1b5585'}} >
                    <h5 className="mb-3 text-white">Quick Links</h5>
                    <ul className="list-unstyled">
                    <li>
                        <a href="https://oia.iittp.ac.in/" target='_blank' className="text-white d-block mb-2"><i className="text-white me-1 fa fa-building"></i>Global Engagement, Alumni and Corporate Relations</a></li>
                    </ul>
                </div>
                </div>
            

            </div>
        </div> */}

        {/* <div className="container"><a target='_blank'  href="https://oia.iittp.ac.in/" className="text-center btn-small btn-primary mt-2 mb-2" >Global Engagement, Alumni and Corporate Relations</a></div>
         */}

        </>
    );
}

export default DarkVariantExample;